import { FC, ReactNode } from 'react';
import { Box, Stack, StackProps } from '@chakra-ui/react';

import Heading from 'components/_core/Heading';
import Text from 'components/_core/Text';

interface HeaderProps extends StackProps {
  action?: ReactNode;
  title: string;
  description?: string;
}

const Header: FC<HeaderProps> = ({ action, description, title, ...props }) => (
  <Stack paddingBottom="space-32" spacing="space-8" {...props}>
    <Stack direction="row" justifyContent="space-between">
      <Heading size="lg">{title}</Heading>
      {action}
    </Stack>

    {description ? (
      <Box maxWidth="37.5rem">
        <Text size="lg">{description}</Text>
      </Box>
    ) : null}
  </Stack>
);
export default Header;
